import { render, staticRenderFns } from "./article-hero.vue?vue&type=template&id=1051a170&"
import script from "./article-hero.vue?vue&type=script&lang=js&"
export * from "./article-hero.vue?vue&type=script&lang=js&"
import style0 from "./article-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports